import { useState, useEffect } from "react";
import {
  getAllCountries,
  getRegionsByCountry,
  getDistrictsByRegion,
  createTehsil,
} from "../Api/TehsilMaster";
import {
  Accordion,
  AccordionItem,
  AccordionBody,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const TehsilMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [districts, setDistricts] = useState([]);

  const [tehsilData, setTehsilData] = useState({
    code: "",
    description: "",
    country: "",
    region: "",
    district: "",
  });

  // Fetch countries on component mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await getAllCountries();
        setCountries(data);
      } catch (error) {
        toast.error("🦄 Failed to load countries!");
      }
    };
    fetchCountries();
  }, []);

  // Fetch regions when country changes
  useEffect(() => {
    const fetchRegions = async () => {
      if (tehsilData.country) {
        try {
          const data = await getRegionsByCountry(tehsilData.country);
          setRegions(data);
          // Reset region and district when country changes
          setTehsilData((prev) => ({
            ...prev,
            region: "",
            district: "",
          }));
          setDistricts([]);
        } catch (error) {
          toast.error("🦄 Failed to load regions!");
        }
      } else {
        setRegions([]);
        setDistricts([]);
        setTehsilData((prev) => ({
          ...prev,
          region: "",
          district: "",
        }));
      }
    };
    fetchRegions();
  }, [tehsilData.country]);

  // Fetch districts when region changes
  useEffect(() => {
    const fetchDistricts = async () => {
      if (tehsilData.region) {
        try {
          const data = await getDistrictsByRegion(tehsilData.region);
          setDistricts(data);
          // Reset district when region changes
          setTehsilData((prev) => ({
            ...prev,
            district: "",
          }));
        } catch (error) {
          toast.error("🦄 Failed to load districts!");
        }
      } else {
        setDistricts([]);
        setTehsilData((prev) => ({
          ...prev,
          district: "",
        }));
      }
    };
    fetchDistricts();
  }, [tehsilData.region]);

  const handleChange = (e) => {
    setTehsilData({ ...tehsilData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createTehsil(tehsilData);
      toast.success("🦄 Tehsil Added Successfully");
      setTehsilData({
        code: "",
        description: "",
        country: "",
        region: "",
        district: "",
      });
    } catch (error) {
      toast.error("🦄 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container gl-master-fields">
        <h2 className="fields-title">Tehsil Master</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0" className="gl-master-accordion">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Tehsil Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="code"
                        value={tehsilData.code}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Description <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={tehsilData.description}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Country Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="country"
                        value={tehsilData.country}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option
                            key={country.countryCode}
                            value={country.countryCode}
                          >
                            {country.countryCode} - {country.countryName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Region Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="region"
                        value={tehsilData.region}
                        onChange={handleChange}
                        required
                        disabled={!tehsilData.country}
                      >
                        <option value="">Select Region</option>
                        {regions.map((region) => (
                          <option
                            key={region.regionCode}
                            value={region.regionCode}
                          >
                            {region.regionCode} - {region.regionName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        District Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="district"
                        value={tehsilData.district}
                        onChange={handleChange}
                        required
                        disabled={!tehsilData.region}
                      >
                        <option value="">Select District</option>
                        {districts.map((district) => (
                          <option key={district.code} value={district.code}>
                            {district.code} - {district.description}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>

          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button variant="primary" type="submit" className="fields-submit">
              Save Tehsil
            </Button>
          </div>
        </Form>
      </div>

      {/* Loader Overlay with Sample 14 */}
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default TehsilMaster;
